export const GET_USAGE_DETAILS = "GET_USAGE_DETAILS"
export const SET_USAGE_DETAILS = "SET_USAGE_DETAILS"